import { AuthProvider, useAuth } from "./auth/AuthContext";
import AuthScreens from "./auth/AuthScreens";
import OutletSetup from "./auth/OutletSetup";
import KitchenShell from "./KitchenShell";
import PublicInvoice from "./views/PublicInvoice";
import AdminApp from "./admin/AdminApp";
import PublicKitchen from "./views/PublicKitchen";
import PublicDigest from "./views/PublicDigest";
import PublicWeekly from "./views/PublicWeekly";
import DownloadPage from "./download/DownloadPage";
import "./responsive.css";
import "./auth/auth.css";
import "./admin/admin.css";

function Loader() {
  return (
    <div className="app-loading" data-testid="app-loading">
      <div className="pulse-dot" />
      <p>Loading your FynDine workspace…</p>
    </div>
  );
}

function Gate() {
  const auth = useAuth();
  if (!auth) return <Loader />;
  const { user } = auth;
  if (user === null) return <Loader />;
  if (!user) return <AuthScreens />;
  if (user.role === "super_admin") return <AdminApp />;
  if (!user.setup_complete) return <OutletSetup />;
  return <KitchenShell />;
}

export default function App() {
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const invoiceMatch = path.match(/^\/invoice\/([a-zA-Z0-9-]+)\/?$/);
  if (invoiceMatch) {
    return <PublicInvoice invoiceId={invoiceMatch[1]} />;
  }
  const digestMatch = path.match(/^\/digest\/([a-zA-Z0-9-]+)\/?$/);
  if (digestMatch) {
    return <PublicDigest digestId={digestMatch[1]} />;
  }
  const weeklyMatch = path.match(/^\/weekly\/([a-zA-Z0-9-]+)\/?$/);
  if (weeklyMatch) {
    return <PublicWeekly reportId={weeklyMatch[1]} />;
  }
  const kdsMatch = path.match(/^\/kds\/([a-zA-Z0-9_-]+)\/?$/);
  if (kdsMatch) {
    return <PublicKitchen token={kdsMatch[1]} />;
  }
  if (/^\/download\/?$/.test(path)) return <DownloadPage />;
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  );
}
